import { Line, LineConfig } from '@ant-design/charts'
import React, { useMemo } from 'react'

import { FanReportsColorKeys, FanReportsColors } from '@/constants/fan-reports-chart-colors'

import FansReportsTooltip, { FansReportsChartData } from './fans-reports-tooltip'

export interface FansReportsChartProps {
  data: FansReportsChartData[]
}

export default function FansReportsLineChart({ data }: FansReportsChartProps) {
  const config: LineConfig = useMemo(() => {
    return {
      data,
      xField: 'dateStr',
      yField: 'count',
      seriesField: 'name',
      colorField: 'name',
      point: {
        zIndex: 2,
        style: {
          stroke: (d: { name: FanReportsColorKeys }) => FanReportsColors[d.name],
          fill: 'white',
          lineWidth: 1.5,
        },
      },
      style: {
        stroke: (d: [{ name: FanReportsColorKeys }]) => FanReportsColors[d[0].name],
        lineWidth: 1.5,
      },
      axis: {
        x: {
          labelAutoRotate: false,
        },
      },
      tooltip: {
        title: 'dateStr',
        items: [
          (d: (typeof data)[number]) => {
            return {
              name: d.name,
              value: d.count,
            }
          }],
      },
      legend: {
        color: {
          itemMarker: 'circle',
          itemMarkerFill(d: { id: FanReportsColorKeys }) {
            return FanReportsColors[d.id]
          },
          title: false,
          position: 'bottom',
          rowPadding: 5,
          layout: {
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          },
        },
      },
      height: 320,
      interaction: {
        tooltip: {
          render: (_: object, options: { title: string, items: { origin: FansReportsChartData[] }[] }) => {
            const origin = data.filter(item => item.dateStr === options.title)
            return <div data-type="react">
              <FansReportsTooltip dateStr={options.title} data={origin} />
            </div>
          },
        },
      },
    }
  }, [data])

  return <Line {...config} />
}